import { getColor } from 'common/constants/_colors';
import { LINE_HEIGHT } from 'common/constants/sizes';
import Icon from 'components/base/Icon';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import styled from 'styled-components';

export const RadiusFlex = styled(Flex)`
  border-radius: 4px;
`;

export const DragBoxFlex = styled(Flex)`
  flex-grow: 1;
  width: 50%;
  border: 1px solid ${getColor('catskillWhite')};
  border-radius: 4px;
  padding: 1rem;
  margin: 1rem;
  height: 39rem;
`;

export const HeaderLine = () => (
  <Flex width='100%' justify='space-between' padding='small' pt='medium'>
    <Flex content='center' items='center' pl='x-small'>
      <Icon name='stars' color='deluge' size='medium' />
      <Text size='x-x-large' pl='1rem' weight='300'>
        Customize Table
      </Text>
    </Flex>
  </Flex>
);

export const Title = ({ title, subtitle }) => (
  <Flex direction='column' pb='medium'>
    <Text size='large'>{title}</Text>
    <Text
      pt='0.5rem'
      size='medium'
      color='shuttleGray'
      lineHeight={LINE_HEIGHT.medium}
    >
      {subtitle}
    </Text>
  </Flex>
);
